// status fields and start button in UI
var phraseDiv;
var startRecognizeButton;

// subscription key and region for speech services.
// var subscriptionKey = "774ddfd8cd7b49858eb5f39bfb421430", serviceRegion = "eastasia";

// production
var subscriptionKey = "97eb05514ff84b12957f09489357a82b", serviceRegion = "eastasia";
var SpeechSDK;
var recognizer;

var isSettingLang = false
var selectedLang = null
var startTime = 0
var limitTime = 30
var timer


$(function () {

    startRecognizeButton = $("#rd-start-voice");

    phraseDiv = $("#rd-input-text");

    // {{-- 選擇語言 --}}
    $('.rd-select-lang').on('click', function () {
        isSettingLang = true
        selectedLang = $(this).data('key')
        $('#rd-setting-voice-pop').fadeOut()
        $('#rd-lang').text($(this).data('key'))
        stopRecognition()
        $('#rd-setting-voice').show()
        console.log($(this).data('key'))
        console.log($(this).data('lang'))
        $('meta[name="voice-lang"]').attr('content', $(this).data('lang'))
    })

    // {{-- 打開語言跳框 --}}
    $('#rd-setting-voice').on('click', function () {
        $('#rd-setting-voice-pop').fadeIn()
    })

    startRecognizeButton.on('click', function () {
        if(isSettingLang){
            // 開啟計時器
            startTimer()
            $('#rd-start-voice').hide()
            $('#rd-process-voice').show()
            startRecognizeButton[0].disabled = true;

            var speechConfig = SpeechSDK.SpeechConfig.fromSubscription(subscriptionKey, serviceRegion);

            speechConfig.speechRecognitionLanguage = selectedLang;
            var audioConfig  = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
            recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);

            // 開始持續語音識別
            recognizer.startContinuousRecognitionAsync();

            // 當有語音識別結果時觸發
            recognizer.recognized = (s, e) => {

                if(e.result.text !== "" && e.result.text !== "undefined" && e.result.text !== undefined && e.result.text !== null) {
                    $('meta[name="use-voice"]').attr('content', 1)
                    // 如果有接收到語音的話，就將計時器歸 0
                    startTime = 0

                    phraseDiv[0].innerText += e.result.text;
                }
            };
        }else{
            $('#rd-setting-voice').click()
        }
    })

    if (!!window.SpeechSDK) {
        SpeechSDK = window.SpeechSDK;
        startRecognizeButton[0].disabled = false;
    }


    $('#rd-stop-voice').on('click', function () {
        stopRecognition()
    })

    $('#rd-close-voice-pop').on('click', function () {
        $('#rd-setting-voice-pop').hide()
    })
})

// 開啟計時器
function startTimer() {
    timer = setInterval(function () {
        startTime++

        if(startTime >= limitTime){
            stopRecognition()
        }
    }, 1000)
}

// 重置計時器
function resetTimer() {
    clearInterval(timer)
}

// 當你想手動停止時，可以使用這個方法
window.stopRecognition = function () {
    if(recognizer){
        resetTimer()
        recognizer.stopContinuousRecognitionAsync(() => {
            console.log("Recognition stopped.");

            recognizer.close();
            recognizer = undefined;

            startRecognizeButton[0].disabled = false;

            $('#rd-process-voice').hide()
            $('#rd-start-voice').show()
        });
    }
}
